export default "__VITE_ASSET__qtn50aA8__"